export default __webpack_public_path__ + "locales/sr-Latn-RS/Article.json?hash=54ca2b88f38880e74f3628467c5e6e43";